import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=54c27ff6"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"
import style0 from "./BankAccounts.vue?vue&type=style&index=0&id=54c27ff6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports